import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CSAgentLoginFormComponent } from '@spartacus/asm/components';
import { FormErrorsComponent } from '@spartacus/storefront';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'cx-csagent-login-form',
    templateUrl: './kn-br-csagent-login-form.component.html',
    styleUrls: ['./kn-br-csagent-login-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, ReactiveFormsModule, FormErrorsComponent, TranslatePipe]
})
export class KnBrCSAgentLoginFormComponent extends CSAgentLoginFormComponent implements OnInit {
  constructor(protected fb: FormBuilder) {
    super(fb);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
